export default __webpack_public_path__ + "static/media/logo_doken.5045703a.png";